// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-module--badge--2JAAO","primary":"badge-module--primary--1T9jS","secondary":"badge-module--secondary--3fLfY","link":"badge-module--link--2uTCQ"};